import React, { useEffect, useState } from 'react';
import API from '../../services/api';
import colors from '../../assets/colors';
import { getWidgetOptions } from '../../utils/widgets';
import { buildMobileRequest, adaptMobileResponse } from '../../analyticsWidgets/mobile';

// Rendering and I/O stay in the dashboard; the catalog and adapters are portable.
const AnalyticsViewWidget = ({ definition, filters, project, portal, isBrand, lastUpdated }) => {
  const [result, setResult] = useState({});
  const scope = isBrand || project?.isBrandPortal
    ? { brandPortalId: portal?.id || project?.id } : { projectId: project?.id };
  const request = buildMobileRequest(definition, filters, scope);
  const requestKey = JSON.stringify([definition.viewId, request, lastUpdated]);
  useEffect(() => {
    const [viewId, payload] = JSON.parse(requestKey);
    if (!payload) return undefined;
    let active = true;
    API.getAnalyticsViewData(viewId, payload).then(response => {
      if (active) setResult({ key: requestKey, response });
    }).catch(error => {
      if (active) setResult({ key: requestKey, error: error?.detail || error?.message || error?.title || 'Failed to load analytics.' });
    });
    return () => { active = false; };
  }, [requestKey]);
  const current = result.key === requestKey ? result : {};
  const adapted = current.response ? adaptMobileResponse(definition, current.response, filters) : { data: [] };
  return <widget-container id={definition.id} widget-title={definition.title} display={definition.display}
    info={JSON.stringify(definition.info)} format={definition.format} unit={definition.unit}
    config={JSON.stringify({ ...definition.config, colors: colors.mainPallet })}
    plot-options={JSON.stringify(adapted.plotOptions || definition.plotOptions)}
    options={getWidgetOptions(definition)} data={JSON.stringify(definition.display === 'donut' ? { datasets: adapted.data } : adapted.data)}
    is-loading={Boolean(filters.campaignsReady === false || (request && !current.response && !current.error))}>
    <span slot="header-left" role="alert" className="small">{current.error || ''}</span>
  </widget-container>;
};
export default AnalyticsViewWidget;
